export default __webpack_public_path__ + "static/media/icon_accommodation.4477cb5f.svg";